import React from "react";
import { AppListing } from "../../../../components/appListing";
import { barriersCols } from "../../constant";

const CareplanBarriers = ({ listData = [], loading = false }) => {
  return (
    <div className="py-2">
      <AppListing
        loading={loading}
        listData={listData}
        cols={barriersCols}
      />
    </div>
  );
};

export default CareplanBarriers;
